module.exports = __webpack_public_path__ + "img/moi.0cd2507e.webp";